// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { NewsFeedEffects } from './store/effects';
import * as fromNewsFeed from './store/reducer';

// SERVICES
import { NewsFeedStoreService } from './news-feed-store.service';
import { NewsFeedService } from './services/news-feed.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['NewsFeed'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure newsfeed ngrx related stuff.
 *
 *   @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 * Notes:-
 * Date: 18/06/2020 Newsfeed store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('NewsFeed', fromNewsFeed.reducer, { metaReducers }),
    EffectsModule.forFeature([NewsFeedEffects]),
  ],
  declarations: [],
  providers: [
    NewsFeedService,
    NewsFeedStoreService,
  ],
})
export class NewsFeedStoreModule { }
